import { render, staticRenderFns } from "./CampoVacio.vue?vue&type=template&id=37d3a93b&scoped=true&functional=true&"
var script = {}
import style0 from "./CampoVacio.vue?vue&type=style&index=0&id=37d3a93b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "37d3a93b",
  null
  
)

export default component.exports